// @flow strict

import * as React from 'react';
import styles from './styles.scss';
import type { CategoryType } from '../types';

export default (props: { categories: Array<CategoryType> }) => (
  <ul>
    {props.categories.map((category, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <li key={index}>
        <a href={category.href} className={styles.link}>
          {category.name}
        </a>
      </li>
    ))}
  </ul>
);
